module.exports = __webpack_public_path__ + "img/ali-al-saady.4f67bf9e.jpg";